<div class="landing-page">
  <mat-sidenav-container [hasBackdrop]="false">
    <mat-sidenav-content>
      <div class="overlay-backdrop" [@slideInOut]="animationState">
        <div class="landing-page__content" *ngIf="isFishingMap || (isStategMap && !(waterwayRegion$ | async)?.isLoading)">
          <p class="landing-page__title" *ngIf="isFishingMap">Explore Fishidy's Fishing Maps</p>
          <p class="landing-page__describe mb-50" *ngIf="isFishingMap">
            Fishidy is a waterway location based social network for people who love to fish.
          </p>
          <p class="landing-page__title" *ngIf="isStategMap">{{ region?.text }} Fishing Reports</p>
          <p class="landing-page__describe mb-50" *ngIf="isStategMap">
            Discover waterways in {{ state }} with interactive maps containing recent catches, fishing spots, and reports of the latest
            fishing activity.
          </p>
          <div class="landing-page__search" cdkScrollable>
            <input class="landing-page__search-input" [(ngModel)]="searchText" placeholder="Waterway or zip code" />
            <mat-icon
              svgIcon="waterwayBlackIcon"
              class="landing-page__search-waterways-icon"
              (click)="getLocation()"
              matTooltip="Find waterways and activity happening near your current location"
              matTooltipPosition="above"
              matTooltipClass="landing-page-tooltip above"
            ></mat-icon>
            <button class="landing-page__search-button-icon" (click)="searchWaterways(searchText)">
              <mat-icon svgIcon="mapSearchIcon" *ngIf="!isLoading"></mat-icon>
              <mat-spinner [diameter]="24" *ngIf="isLoading"></mat-spinner>
            </button>
          </div>
          <div class="landing-page__other">
            <span>OR</span>
            <button class="landing-page__other-button" (click)="interactiveMap('overlay-backdrop')">Explore The Interactive Map</button>
          </div>
        </div>
        <div class="landing-page__content" *ngIf="isWaterwayMap && (waterwayLanding$ | async)?.result?.waterway as waterway">
          <p class="landing-page__title">{{ waterway.name }}</p>
          <p class="landing-page__describe">
            {{ waterway.county }} - <a [routerLink]="createMapUrl({ state: waterway.state })">{{ waterway.state }}</a>
          </p>
          <p class="landing-page__describe mb-50">{{ truncate(waterway.description) }}</p>
          <div class="landing-page__icons mb-30">
            <div class="icon_item">
              <div class="icon"><mat-icon svgIcon="catchOvIcon" mat-list-icon></mat-icon></div>
              <span>{{ waterway.catchCount || 0 }}</span>
            </div>
            <div class="icon_item">
              <div class="icon"><mat-icon svgIcon="spotOvIcon" mat-list-icon></mat-icon></div>
              <span>{{ waterway.spotCount || 0 }}</span>
            </div>
            <div class="icon_item">
              <div class="icon"><mat-icon svgIcon="followerIcon" mat-list-icon></mat-icon></div>
              <span>{{ waterway.memberCount || 0 }}</span>
            </div>
          </div>
          <div class="landing-page__other">
            <button class="landing-page__other-button" (click)="navigateSignup()">View Map</button>
          </div>
        </div>
      </div>
      <app-mapbox [style]="style" [center]="defaultCenter" [zoom]="4.3" (load)="mapLoad($event)"></app-mapbox>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <div class="pt-30"></div>
  <div class="fetching">
    <app-spinner *ngIf="isStategMap" [isFetching]="(waterwayRegion$ | async)?.isLoading"></app-spinner>
    <app-spinner *ngIf="isWaterwayMap" [isFetching]="(waterwayLanding$ | async)?.isLoading"></app-spinner>
  </div>

  <div class="page-content" *ngIf="isFishingMap">
    <app-landing-map-features class="w-100"></app-landing-map-features>
    <app-landing-find-waterways class="w-100"></app-landing-find-waterways>
    <app-landing-featured-anglers [users]="(userFeatured$ | async).result || []" class="w-100"></app-landing-featured-anglers>
    <div class="signup page" id="signup">
      <div class="content">
        <app-sign-up-free [showHeader]="false"></app-sign-up-free>
      </div>
    </div>
    <app-footer-layout></app-footer-layout>
  </div>

  <div class="page-content" *ngIf="isStategMap && (waterwayRegion$ | async)?.result as waterwayRegion">
    <app-landing-activity [stream]="waterwayRegion.stream" class="w-100" [name]="region?.text"></app-landing-activity>
    <app-landing-popular-waterways
      [waterways]="waterwayRegion.waterways"
      [name]="region?.text"
      class="w-100"
    ></app-landing-popular-waterways>
    <app-landing-featured-anglers [users]="waterwayRegion.featuredUsers" class="w-100"></app-landing-featured-anglers>
    <div class="signup page" id="signup">
      <div class="content">
        <app-sign-up-free [showHeader]="false"></app-sign-up-free>
      </div>
    </div>
    <app-footer-layout></app-footer-layout>
  </div>

  <div class="page-content" *ngIf="isWaterwayMap && (waterwayLanding$ | async)?.result as waterwayLanding">
    <app-landing-activity [stream]="waterwayLanding.stream" class="w-100" [name]="waterwayLanding?.waterway?.Name"></app-landing-activity>
    <app-landing-popular-waterways
      [waterways]="waterwayLanding.nearbyWaterways"
      [name]="waterwayLanding?.waterway?.State"
      class="w-100"
    ></app-landing-popular-waterways>
    <app-landing-featured-anglers [users]="waterwayLanding.featuredUsers" class="w-100"></app-landing-featured-anglers>
    <div class="signup page" id="signup">
      <div class="content">
        <app-sign-up-free [showHeader]="false"></app-sign-up-free>
      </div>
    </div>
    <app-footer-layout></app-footer-layout>
  </div>
</div>
